<div class="unauthorized-container">
  <div class="unauthorized-content">
    <h1>Access Denied</h1>
    <p>You do not have permission to access this page.</p>
    <button class="btn btn-primary" (click)="navigateHome()">Return to Home</button>
  </div>
</div>
